// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var DomElementIdentifierGenerator$SmartcutsMacros = require("../../../DomElementIdentifierGenerator.bs.js");

function contentDiff_encode(encoder_domHtmlElement, v) {
  return Js_dict.fromArray([
              [
                "contentEditableHost",
                Curry._1(encoder_domHtmlElement, v.contentEditableHost)
              ],
              [
                "lastValue",
                Decco.stringToJson(v.lastValue)
              ],
              [
                "newValue",
                Decco.stringToJson(v.newValue)
              ],
              [
                "timestamp",
                Decco.floatToJson(v.timestamp)
              ]
            ]);
}

function contentDiff_decode(decoder_domHtmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var contentEditableHost = Curry._1(decoder_domHtmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "contentEditableHost"), null));
  if (contentEditableHost.TAG === /* Ok */0) {
    var lastValue = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastValue"), null));
    if (lastValue.TAG === /* Ok */0) {
      var newValue = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "newValue"), null));
      if (newValue.TAG === /* Ok */0) {
        var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
        if (timestamp.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    contentEditableHost: contentEditableHost._0,
                    lastValue: lastValue._0,
                    newValue: newValue._0,
                    timestamp: timestamp._0
                  }
                };
        }
        var e = timestamp._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".timestamp" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = newValue._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".newValue" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = lastValue._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".lastValue" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = contentEditableHost._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".contentEditableHost" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function event_encode(encoder_domHtmlElement, encoder_domEvent, v) {
  if (typeof v === "number") {
    return ["ParentDidAskChildToExit"];
  } else if (v.TAG === /* ContentDiff */0) {
    return [
            "ContentDiff",
            contentDiff_encode(encoder_domHtmlElement, v._0)
          ];
  } else {
    return [
            "EventTransported",
            Curry._1(encoder_domEvent, v._0),
            Decco.floatToJson(v._1)
          ];
  }
}

function event_decode(decoder_domHtmlElement, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ContentDiff" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = contentDiff_decode(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContentDiff */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "EventTransported" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Curry._1(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* EventTransported */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "ParentDidAskChildToExit" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ParentDidAskChildToExit */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyContentDiff(stringifyDomHtmlElement, param) {
  return "{contentEditableHost: " + (Curry._1(stringifyDomHtmlElement, param.contentEditableHost) + (", lastValue: " + (param.lastValue + (", newValue: " + (param.newValue + (", timstamp: " + (param.timestamp.toString() + "}")))))));
}

function mapContentDiff(mapDomHtmlElement, param) {
  return {
          contentEditableHost: Curry._1(mapDomHtmlElement, param.contentEditableHost),
          lastValue: param.lastValue,
          newValue: param.newValue,
          timestamp: param.timestamp
        };
}

function stringifyEvent(stringifyDomHtmlElement, stringifyDomEvent, $$event) {
  if (typeof $$event === "number") {
    return "ParentDidAskChildToExit";
  } else if ($$event.TAG === /* ContentDiff */0) {
    return "ContentDiff(" + (stringifyContentDiff(stringifyDomHtmlElement, $$event._0) + ")");
  } else {
    return "EventTransported(event=" + (Curry._1(stringifyDomEvent, $$event._0) + (", timestamp=" + ($$event._1.toString() + ")")));
  }
}

function mapEvent(mapDomHtmlElement, mapDomEvent, $$event) {
  if (typeof $$event === "number") {
    return /* ParentDidAskChildToExit */0;
  } else if ($$event.TAG === /* ContentDiff */0) {
    return {
            TAG: /* ContentDiff */0,
            _0: mapContentDiff(mapDomHtmlElement, $$event._0)
          };
  } else {
    return {
            TAG: /* EventTransported */1,
            _0: Curry._1(mapDomEvent, $$event._0),
            _1: $$event._1
          };
  }
}

function extractRespondToBgFromEvent(v) {
  
}

var domElementIdentifierGenerator = DomElementIdentifierGenerator$SmartcutsMacros.make(undefined);

exports.contentDiff_encode = contentDiff_encode;
exports.contentDiff_decode = contentDiff_decode;
exports.event_encode = event_encode;
exports.event_decode = event_decode;
exports.stringifyContentDiff = stringifyContentDiff;
exports.mapContentDiff = mapContentDiff;
exports.stringifyEvent = stringifyEvent;
exports.mapEvent = mapEvent;
exports.extractRespondToBgFromEvent = extractRespondToBgFromEvent;
exports.domElementIdentifierGenerator = domElementIdentifierGenerator;
/* domElementIdentifierGenerator Not a pure module */
